'use es6';

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { DragLayer } from 'react-dnd';
import MenuRootPreview from 'simple-menus-lib/components/dnd/preview/MenuRootPreview';
import { jsx as _jsx } from "react/jsx-runtime";
const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%'
};
class MenuDragLayer extends PureComponent {
  constructor(props) {
    super(props);
    this.getItemStyles = this.getItemStyles.bind(this);
  }
  getItemStyles() {
    const {
      currentOffset,
      item
    } = this.props;
    if (!currentOffset) {
      return {
        display: 'none'
      };
    }
    const {
      x,
      y
    } = currentOffset;
    const transform = `translate(${x}px, ${y}px) translateZ(0)`;
    return {
      transform,
      WebkitTransform: transform,
      maxWidth: item.width,
      willChange: 'transform'
    };
  }
  render() {
    const {
      item,
      isDragging
    } = this.props;
    if (!isDragging) {
      return null;
    }
    return /*#__PURE__*/_jsx("div", {
      style: layerStyles,
      children: /*#__PURE__*/_jsx("div", {
        style: this.getItemStyles(this.props),
        children: /*#__PURE__*/_jsx(MenuRootPreview, {
          id: item.id,
          parentId: item.parentId,
          menuId: item.menuId
        })
      })
    });
  }
}
MenuDragLayer.propTypes = {
  item: PropTypes.object,
  currentOffset: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired
  }),
  isDragging: PropTypes.bool.isRequired
};
export default DragLayer(monitor => ({
  item: monitor.getItem(),
  itemType: monitor.getItemType(),
  currentOffset: monitor.getSourceClientOffset(),
  isDragging: monitor.isDragging()
}))(MenuDragLayer);